import { render } from "./SuiviDemarches.vue?vue&type=template&id=5d563178&scoped=true"
import script from "./SuiviDemarches.vue?vue&type=script&lang=js"
export * from "./SuiviDemarches.vue?vue&type=script&lang=js"

import "./SuiviDemarches.vue?vue&type=style&index=0&id=5d563178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d563178"]])

export default __exports__